import { render } from "./RecordHistory.vue?vue&type=template&id=49473e48&scoped=true&ts=true"
import script from "./RecordHistory.vue?vue&type=script&lang=ts"
export * from "./RecordHistory.vue?vue&type=script&lang=ts"

import "./RecordHistory.vue?vue&type=style&index=0&id=49473e48&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49473e48"]])

export default __exports__